import(/* webpackMode: "eager" */ "/tmp/8df0f1fc773ec85/app/[locale]/error.tsx");
